import React from 'react'
import { Link } from 'react-router-dom'

export default function Resume() {
  
  return (
    <div className='resume-page bg-slate-900 grid md:grid-cols-10 pt-16 text-gray-50 pb-12 font-sans'>

        <div className='flex-wrap justify-center md:col-start-1 md:col-span-2'>
          <h1 className='text-4xl font-semibold p-1 pl-3 md:pl-8 mb-4 text-left'>Billy Best</h1>
          <div className='p-1 pl-3 md:pl-8 text-left'><p><a href='mailto:bbest12g@gmail.com'>bbest12g@gmail.com</a></p></div>
          <div className='p-1 pl-3 md:pl-8 text-left'><p><a href='https://github.com/iFrogHop2Worlds'>github.com/iFrogHop2Worlds</a></p></div>

          <div className='mb-2 p-3 md:p-8 text-left'>
            <p>
              Currently founding a software company focused on commerce solutions and doing rnd in database technology
            </p>
          </div>

          {/*<div className='mt-32 p-3 hidden md:inline-block'>*/}
          {/*  <h2 className='text-white text-2xl'>Certifications</h2>*/}
          {/*  <p>M220JS: MongoDB for JavaScript Developers</p>*/}
          {/*  <p className='text-md font-light'><a href='https://university.mongodb.com/course_completion/3ffe1524-40e9-4fc9-90b0-82d0e0b2d99a?*/}
          {/*  utm_source=copy&utm_medium=social&utm_campaign=university_social_sharing'>certificate link</a></p>*/}

          {/*  <p>M121: MongoDB Aggregation Framework</p>*/}
          {/*  <p className='text-md font-light'><a href='https://university.mongodb.com/course_completion/850b51a0-5bc3-4eb4-912b-ea6e39433cdb?*/}
          {/*  utm_source=copy&utm_medium=social&utm_campaign=university_social_sharing'>certificate link</a></p>*/}

          {/*  <p>M001: MongoDB Basics</p>*/}
          {/*  <p className='text-md font-light'><a href='https://university.mongodb.com/course_completion/aa16fe03-3da8-4e0f-a60e-6971a84ef0d2?*/}
          {/*  utm_source=copy&utm_medium=social&utm_campaign=university_social_sharing'>certificate link</a></p>*/}

          {/*  <p>JavaScript Data Structures and Algorithms</p>*/}
          {/*  <p className='text-md font-light'><a href='https://freecodecamp.org/certification/illbill/javascript-algorithms-and-data-structures'>certificate link</a></p>*/}
          {/*  */}
          {/*  <p>Portswigger/Burpsuite cert coming soon</p>*/}
          {/*</div>*/}
        </div>

        <div className='md:col-start-3 md:col-span-6 p-3 text-left'>
            <h3 className='bg-blue-950 text-xl text-center font-semibold m-1 mt-6 mb-2 pt-2 pb-2 shadow-md shadow-black text-white'>Work
                Experience</h3>
            <div className='flex mt-2 mb-3'>
                <p className='font-thin text-cyan-500 pr-2 underline'>Freelance web development</p>
                <i>January 2020 to 2023</i>
            </div>
            <p className='text-left'>
                I have collaborated with small to mid-sized companies to build dozens of e-commerce websites from the
                ground up and enhance
                functionality for existing platforms. My experience spans both front-end and back-end development, where
                I have:
                <ul className="list-none pl-0 mt-2 mb-2">
                    <li className="before:content-['\2192'] before:pr-2">Designed and implemented custom themes and user
                        flows
                    </li>
                    <li className="before:content-['\2192'] before:pr-2">Developed robust user authentication systems
                    </li>
                    <li className="before:content-['\2192'] before:pr-2">Created backend dashboards for CMS, analytics,
                        and tools
                    </li>
                    <li className="before:content-['\2192'] before:pr-2">Integrated payment processing solutions,
                        including Stripe and PayPal
                    </li>
                    <li className="before:content-['\2192'] before:pr-2">Processed and formatted data for CSV file
                        output
                    </li>
                    <li className="before:content-['\2192'] before:pr-2">DB design, setup.</li>
                    <li className="before:content-['\2192'] before:pr-2">Updated legacy codebases (react/webpack)</li>
                </ul>

                My work adheres to best practices, prioritizing availability, search engine optimization (SEO), and
                performance optimization.
                I have worked extensively with a range of technologies, including PHP/WordPress, JavaScript
                (React/Next.js, Node.js), and Rust.

            </p>

            <div className='flex mt-2 mb-3'>
                <p className='font-thin text-cyan-500 pr-2 underline'>Web technology consultant</p>
                <i>January 2023</i>
            </div>
            <p className='text-left'>
                Leveraging my technical expertise, I collaborated with a dispensary to identify and address their unique
                goals and challenges.
                Through a comprehensive discovery process, the client and I worked together to assess their needs, which
                informed a detailed
                technical analysis of their digital infrastructure.

                I proposed a range of tailored solutions, each evaluated based on cost, timeline, and the extent of
                problem coverage. Additionally,
                I developed a flexible development roadmap that allowed for adjustments based on the trade-offs the
                client was willing to consider.

                This structured approach provided the client with a clear and actionable path to scale their operations
                and streamline key processes
                efficiently.
            </p>

            <h3 className='bg-blue-950 text-xl text-center font-semibold m-1 mt-6 mb-2 pt-2 pb-2 shadow-md shadow-black text-white'>Personal
                Work</h3>

            <div className='flex mt-2 mb-3'>
                <p className='font-thin text-cyan-500 pr-2 underline'>Bill's Business Solutions</p>
                <i>coming soon</i>
            </div>
            <p className='text-left'>
                A commerce website where you can purchase software solutions and manage your business operations.
                It is the main hub to interact with the company's products and services.
            </p>

            <hr className='mt-2 pb-2'/>

            <div className='flex mt-2 mb-3'>
                <p className='font-thin text-cyan-500 pr-2 underline'>Bills Bookings</p>
                <i>coming soon</i>
            </div>
            <p className='text-left'>
                A booking system for businesses to manage their services and appointments.
                Has an admin dashboard to manage everything and custom widgets to easily integrate with existing websites and
                an API for developers to use.
                The backend service and API is written in Rust and uses a postgres database. The admin panel is built with React.
            </p>

            <hr className='mt-2 pb-2'/>

            <div className='flex mt-2 mb-3'>
                <p className='font-thin text-cyan-500 pr-2 underline'>Bills Inventory</p>
            </div>
            <p className='text-left'>
                A system to manage inventory for businesses. It allows users to use their phones to scan barcodes to quickly add items to their inventory.
                making it cheaper and easier to deploy scanners, track and manage inventory across multiple locations and companies.
                The backend service is written in Rust and uses a postgres database. The frontend is built with React.
            </p>

            <hr className='mt-2 pb-2'/>

            <div className='flex mt-2 mb-3'>
                <p className='font-thin text-cyan-500 pr-2 underline'>Charter</p>
                {/*<i>comming soon</i>*/}
            </div>
            <p className='text-left'>
                Is a cross-platform program allowing users to quickly navigate
                and visualize their data. Uses an experimental query language/engine (CSVQB) which aims to make queries more intuitive and easier to write for
                non programmers. Supports sql and nosql databases and csv files. Designed to handle large datasets efficiently. Comes with a built-in
                query builder, csv file editor, charting capabilities, and more.
                <br/>
                <a href='https://github.com/iFrogHop2Worlds/charter_csv'>github link</a>
            </p>

            <hr className='mt-2 pb-2'/>

            <div className='flex mt-2 mb-3'>
                <p className='font-thin text-cyan-500 pr-2 underline'>Forge</p>
                {/*<i>comming soon</i>*/}
            </div>
            <p className='text-left'>
                Database engine written in Rust and using a LSM Tree and SSTable for very fast writes and reads. In early
                development, but has promise with early test showing it can likely outperform other engines. Reaching 1-1.67
                million writes per second on a single mid tier machine!
                <br/>
                <a href='https://github.com/iFrogHop2Worlds/forge'>github link</a>
            </p>

            <h3 className='bg-blue-950 text-xl text-center font-semibold m-1 mt-6 mb-2 pt-2 pb-2 shadow-md shadow-black text-white'>Education</h3>
            <p className='font-thin text-white underline mb-2'>Self taught programmer</p>
            <p className='text-left'>
                I have independently studied core disciplines in computer science, including data structures and
                algorithms, computer networking, operating systems, compilers, databases, distributed systems, and more.
            </p>
            <ul className="list-none pl-0 mt-2 mb-2">
                My learning journey includes
                <li className="before:content-['\2192'] before:pr-2">Programming/computer science books</li>
                <li className="before:content-['\2192'] before:pr-2">Online lectures</li>
                <li className="before:content-['\2192'] before:pr-2">Interactive challenges</li>
                <li className="before:content-['\2192'] before:pr-2">Personal projects</li>
                <li className="before:content-['\2192'] before:pr-2">Client projects</li>

            </ul>
        </div>


        <div className='md:col-start-9 md:col-span-2 text-md p-3'>
            <h6 className='text-xl text-white mb-1 underline'>Main tools</h6>
            <p className='text-orange-300'>Rust</p>
            <p className='text-white'>C++</p>
            <p className='text-green-400'>Python</p>
            <p className='text-purple-200'>Solidity</p>
            <p className='text-yellow-200'>Javascript</p>
            <p className='text-blue-200'>Typescript</p>
            <p className='text-indigo-400'>PHP</p>
            <p className='text-green-400'>MongoDB</p>
            <p className='text-sky-200'>PostgreSQL</p>
            <p className='text-red-400'>html</p>
            <p className='text-pink-200'>css</p>


            {/*<h6 className='mt-4 text-xl text-white mb-1 underline'>Learning</h6>*/}
            {/*<p className='text-gray-100'>Graphics/Games</p>*/}
            {/*<p className='text-gray-100'>Game design</p>*/}
            {/*<p className='text-gray-100'>Ethical hacking</p>*/}


            <div className='p-3 '>
                <h2 className='mt-8 text-white text-2xl'>Certifications</h2>
                <p>M220JS: MongoDB for JavaScript Developers</p>
                <p className='text-md font-light'><a href='https://university.mongodb.com/course_completion/3ffe1524-40e9-4fc9-90b0-82d0e0b2d99a?
              utm_source=copy&utm_medium=social&utm_campaign=university_social_sharing'>certificate link</a></p>

                <p>M121: MongoDB Aggregation Framework</p>
                <p className='text-md font-light'><a href='https://university.mongodb.com/course_completion/850b51a0-5bc3-4eb4-912b-ea6e39433cdb?
              utm_source=copy&utm_medium=social&utm_campaign=university_social_sharing'>certificate link</a></p>

                <p>M001: MongoDB Basics</p>
                <p className='text-md font-light'><a href='https://university.mongodb.com/course_completion/aa16fe03-3da8-4e0f-a60e-6971a84ef0d2?
              utm_source=copy&utm_medium=social&utm_campaign=university_social_sharing'>certificate link</a></p>

                <p>JavaScript Data Structures and Algorithms</p>
                <p className='text-md font-light'><a
                    href='https://freecodecamp.org/certification/illbill/javascript-algorithms-and-data-structures'>certificate
                    link</a></p>

                <p>Portswigger/Burpsuite cert coming soon</p>
            </div>
        </div>
    </div>
  )
}
